module.exports = __webpack_public_path__ + "static/media/WIENXTRA_wortmarke_web.2bb8715e.svg";